<template>
<div v-if="sectiondata ">

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="!loading">
  
<template v-if="sectiondata.active.translations.length">
  <template v-for="translation in sectiondata.active.translations">
  <h3 class="text-primary" v-if="$store.state.auth.user.preflang_id == translation.language_id">{{translation.translation}}</h3>
  <template v-if="$store.state.auth.user.preflang_id == translation.language_id">
    <h5 class="pb-3" v-if="translation.description">{{translation.description}}</h5>
  </template>  
</template>
</template>
<template v-else>
  <h3 class="text-primary">{{section.name}}</h3>
</template>


  
<div class="sections pt-3 pb-3" v-if="sectiondata.sections.length>0">

<QuestionlistPreviewSubSectionView v-for="item in sectiondata.sections" :section="item"></QuestionlistPreviewSubSectionView>


</div>


<div class="inputfields pt-2"  v-if="sectiondata.inputfields.length>0">




<CustomInputfield  v-for="item in sectiondata.inputfields" :data="item"></CustomInputfield>
</div>
</template>


</div>
</template>

<script>
import QuestionlistPreviewSubSectionView from "./QuestionlistPreviewSubSectionView"
export default {
  props:["section"],
  name: 'QuestionlistPreviewSubSectionView',

  data () {
    return {
      data:null,
      loading:true,
      sectiondata:null,
    }
  },
  components:{QuestionlistPreviewSubSectionView},
  computed:
  {
    showsection()
    {
      let show = false
      if(this.sectiondata)
      {
        for (let i = 0; i < this.sectiondata.inputfields.length; i++) {

          if(this.sectiondata.inputfields[i].show_field)
          {
            show = true
            break
          }
        }

      }
      return show
    },
    inputfields_updating()
    {
      return this.$store.state.evaluation.inputfields_updating
    }

  },
  watch:{
    inputfields_updating(newval,oldval)
    {
      if(!newval)
      {
        this.getData()
      }
    }
  },
  mounted()
  {
    
    this.getData()
  },
  methods:{
    async getData()
    {
        this.loading = await true
        await this.arrangeSubSectionInputfields(this.section.id)
        this.loading = await false
        //this.data = await this.generalApiGet("audit/section_fields/"+this.$route.params.section_id+"/"+this.$route.params.id)
        //await console.log(this.data);
        //await this.$store.dispatch('evaluation/setActiveSection',this.data) 
        //this.$store.dispatch('evaluation/setActiveParentSectionId',this.$route.params.section_id)
        //this.loading = await false
    },
    arrangeSubSectionInputfields(section_id)
      {
         
          //store.dispatch('evaluation/setSectionLoading',true)
          this.$store.dispatch('evaluation/setSectionLoading',true)
          let sections = this.$store.state.evaluation.sections.filter((item)=>{return item.parent_id == section_id})
          sections  =  sections.sort(this.orderSection)
          let active = this.$store.state.evaluation.sections.find((item)=>{return item.id == section_id})
          let inputfields = this.$store.state.evaluation.inputfields.filter((item)=>{return item.inputfieldsection_id == section_id})
          this.sectiondata = {sections:sections,inputfields:inputfields,active:active}
          if(this.sectiondata.active.id==252)
          {
            
          }
          
          this.$store.dispatch('evaluation/setSectionLoading',false)
      },
  },
}
</script>

<style lang="css" scoped>
</style>